import React, { useEffect } from 'react';
import { useLabels } from 'wsm-common-data';
import { useSelector } from 'react-redux';
import VehicleCard from './VehicleCard';
import { getVehicleTrackingData } from '../utilities/tracking';
import fetchDealerCodesData from '../utilities/fetchDealerCodesData';
import { MINIMUM_VEHICLES } from '../global-constants';

const VehiclesTableRow = () => {
	const vehicles = useSelector((state) => state.vehicles);
	const labels = useLabels();

	useEffect(() => {
		const getDealerCodes = async () => {
			const accountList = [];
			vehicles.forEach((item) => {
				if (accountList.find((account) => account === item.accountId)) {
					return;
				}
				accountList.push(item.accountId);
			});

			const dealerCodesResponse = await fetchDealerCodesData({
				vehicleAccounts: accountList
			});
			return dealerCodesResponse;
		};

		const mockInvDataDDC = (vehicleTracking) => {
			if (window.DDC.WS && vehicleTracking.length > 0) {
				// pass hasDataBusInventory condition
				window.DDC.InvData = {
					srpReady: true,
					inventory: {
						pageInfo: {
							totalCount: vehicleTracking.length
						},
						inventory: vehicleTracking
					}
				};
				window.DDC.WS.state['ws-inv-data'] = true;
				// pass the isSrp condition on inventoryDataChecker
				if (
					window.DDC.dataLayer.page &&
					window.DDC.dataLayer.page.pageInfo
				) {
					window.DDC.dataLayer.page.pageInfo.isVlp = true;
				}
			}
		};

		const initWalletData = async () => {
			if (window && window.DDC && window.DDC.dataLayer) {
				const dealerCodesList = await getDealerCodes();
				const vehicleTracking = getVehicleTrackingData(
					vehicles,
					dealerCodesList
				);
				window.DDC.dataLayer.vehicles = vehicleTracking;
				mockInvDataDDC(vehicleTracking);
			}
		};

		initWalletData();
	}, [vehicles]);

	return (
		<>
			<tr className="sr-only">
				{vehicles.map((vehicle) => {
					const { title, uuid } = vehicle;
					return (
						<th key={uuid} id={uuid} scope="col">
							{title}
						</th>
					);
				})}
			</tr>
			<tr data-testid="vehicles-row">
				{vehicles.map((vehicle, idx) => {
					const headerContent = labels
						.get('NUMBER_OF_TOTAL')
						.replace('{NUMBER}', idx + 1)
						.replace('{TOTAL}', vehicles.length);

					return (
						<td
							key={vehicle.uuid}
							className={`compare-item col-${
								idx + 1
							} border-top-0`}
						>
							<VehicleCard
								vehicle={vehicle}
								headerContent={headerContent}
								showRemoveButton={
									vehicles.length > MINIMUM_VEHICLES
								}
							/>
						</td>
					);
				})}
			</tr>
		</>
	);
};

export default VehiclesTableRow;
